// extracted by mini-css-extract-plugin
export var label = "_jo-2";
export var slideContainer = "_jo-0";
export var slider = "_jo-1";